<script>
	import { Table } from "sveltestrap";

	import LoaderContainer from "../../../components/Loader/LoaderContainerSort.svelte";

	export let data = [];

	const tooltipTriggerList = document.querySelectorAll(
		'[data-bs-toggle="tooltip"]'
	);
	const tooltipList = tooltipTriggerList.forEach((tooltipTrigger) => {
		tooltipTrigger.addEventListener("show.bs.tooltip", function () {
			// You can potentially reduce delays here (if any)
		});
	});
</script>

<LoaderContainer>
	<div class="tbodyDiv">
		<Table responsive hover>
			<thead class="sticky-top">
				<tr>
					<th>Log Id</th>
					<th> Ev Charging Company </th>
					<th> Counts </th>

					<th>Status</th>
					<th>Error</th>
					<!-- <th>Actions</th> -->
				</tr>
			</thead>
			<tbody>
				{#each data as { id, description, status, counts, errorMessages }}
					<tr>
						<td>
							<p>
								<span class="link-text mx-1"> {id} </span>
							</p>
						</td>

						<td>
							<p>
								<span>
									{description}
								</span>
							</p>
						</td>
						<td>
							<p>
								<span class="mx-3">
									{counts || 0}
								</span>
							</p>
						</td>

						<td>
							{#if status === "End Failed"}
								<p class="status-bar bg-danger">
									{status}
								</p>
							{:else if status === "End Success"}
								<p class="status-bar status-bar-1">{status}</p>
							{:else if status === "Running"}
								<p class="status-bar status-bar-2">{status}</p>
							{/if}
						</td>

						<td
							class="col-lg-3"
							data-bs-toggle="tooltip"
							data-bs-placement="bottom"
							title={errorMessages}
						>
							<div class="">
								{`${
									errorMessages
										? errorMessages?.substring(0, 60) +
										  " " +
										  "..."
										: ""
								}`}
							</div>
						</td>
					</tr>
				{/each}
			</tbody>
		</Table>
		{#if data.totalCount == 0}
			<p class="text-center">No data to display</p>
		{/if}
	</div>
</LoaderContainer>

<style>
	.tbodyDiv {
		max-height: clamp(38em, 76vh, 550px);
		overflow: hidden;
		margin-bottom: 15px;
		overflow: auto;
	}
</style>
